import { Button } from '../ui/Button';
import { Checkbox } from '../ui/Checkbox';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '../ui/Dialog';

export type WishlistCollectionOption = {
    id: number;
    name: string;
    selected: boolean;
};

type Props = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title: string;
    description: string;
    collections: WishlistCollectionOption[];
    loading: boolean;
    error: string | null;
    submitLabel: string;
    emptyMessage: string;
    onSelectAll: () => void;
    onCollectionChange: (collectionId: number, selected: boolean) => void;
    onSubmit: () => void;
};

export const WishlistCollectionsDialog = ({
    open,
    onOpenChange,
    title,
    description,
    collections,
    loading,
    error,
    submitLabel,
    emptyMessage,
    onSelectAll,
    onCollectionChange,
    onSubmit,
}: Props) => (
    <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-md">
            <DialogHeader>
                <DialogTitle>{title}</DialogTitle>
                <DialogDescription>{description}</DialogDescription>
            </DialogHeader>

            <div className="max-h-64 space-y-2 overflow-y-auto">
                <label className="flex cursor-pointer items-center gap-3 rounded-xl border px-3 py-2.5">
                    <Checkbox
                        aria-label="Загальний"
                        checked
                        onCheckedChange={() => onSelectAll()}
                    />
                    <span className="text-sm font-medium">Загальний</span>
                </label>

                {loading && collections.length === 0 ? (
                    <p className="py-4 text-center text-sm text-muted-foreground">
                        Завантаження…
                    </p>
                ) : collections.length > 0 ? (
                    collections.map((collection) => (
                        <label
                            key={collection.id}
                            className="flex cursor-pointer items-center gap-3 rounded-xl border px-3 py-2.5"
                        >
                            <Checkbox
                                aria-label={collection.name}
                                checked={collection.selected}
                                onCheckedChange={(checked) =>
                                    onCollectionChange(
                                        collection.id,
                                        checked === true,
                                    )
                                }
                            />
                            <span className="text-sm font-medium">
                                {collection.name}
                            </span>
                        </label>
                    ))
                ) : (
                    <p className="py-4 text-sm text-muted-foreground">
                        {emptyMessage}
                    </p>
                )}
            </div>

            {error && (
                <p className="text-sm text-destructive" role="alert">
                    {error}
                </p>
            )}

            <DialogFooter>
                <Button type="button" onClick={onSubmit} disabled={loading}>
                    {submitLabel}
                </Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
);
